import {selector} from "recoil";
import matriculasSelector from "./matriculasSelector";
import {GetUnidade} from "../../service/unidade-service";

const unidadesDistintasSelector = selector({
  key: 'unidadesDistintasSelector', // unique ID (with respect to other atoms/selectors)
  get: async ({get}) => {
    const matriculas = get(matriculasSelector);
    const unidades = matriculas.map(matricula => matricula?.unidade_Id);
    const unidadesDistintas = [];

    unidades.forEach(unidade => {
      if (!unidadesDistintas.includes(unidade)) {
        unidadesDistintas.push(unidade);
      }
    });

    const detalhes = [];
    const promises = unidadesDistintas.map(async (unidade) => {
      return GetUnidade(unidade);
    });
    const results = await Promise.all(promises);
    results.forEach((result) => {
      detalhes.push(result);
    });

    return detalhes;
  }
});

export default unidadesDistintasSelector